import { branchExistsGuard } from '@features/project/guards/branch-exists.guard';
import { conceptExistsGuard } from '@features/project/guards/concept-exists.guard';
import { Routes } from '@angular/router';
import { authGuard } from '@core/auth/auth.guard';
import { projectExistsGuard } from '@features/project/guards/project-exists.guard';
import { adrExistsGuard } from '@features/project/guards/adr-exists.guard';
import { arc42ChapterExistsGuard } from '@features/project/guards/arc42-chapter-exists.guard';
import { groupExistsGuard } from '@features/project/guards/group-exists.guard';
import { apiSpecificationExistsGuard } from '@features/project/guards/api-specification-exists.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'projects', pathMatch: 'full' },

  {
    path: 'login',
    loadComponent: () => import('@features/login/login.component').then(m => m.LoginComponent),
  },

  // Projektauswahl
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/projects/projects-shell/projects-shell.component').then(
        m => m.ProjectsShellComponent
      ),
    children: [
      {
        path: 'projects',
        loadComponent: () =>
          import('./features/projects/projects-list/projects-list.component').then(
            m => m.ProjectsListComponent
          ),
        title: 'Projekte',
      },
    ],
  },

  // Benutzerbereich (Profil + Einstellungen)
  {
    path: 'user',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/projects/projects-shell/projects-shell.component').then(
        m => m.ProjectsShellComponent
      ),
    children: [
      { path: '', redirectTo: 'settings', pathMatch: 'full' },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/user/settings/settings.component').then(m => m.SettingsComponent),
        title: 'Profil',
      },
    ],
  },

  // Pro-Projekt-Kontext
  {
    path: 'projects/:projectId',
    canActivate: [authGuard, branchExistsGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    canMatch: [projectExistsGuard],
    loadComponent: () =>
      import('./features/project/project-shell/project-shell.component').then(
        m => m.ProjectShellComponent
      ),
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      {
        // The overview is the dashboard (AMONE-104), with no separate route beside it.
        path: 'overview',
        loadComponent: () =>
          import('./features/project/dashboard/dashboard.component').then(
            m => m.DashboardComponent
          ),
        title: 'Übersicht',
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./features/project/search/search.component').then(m => m.SearchComponent),
        title: 'Suche',
      },
      {
        path: 'concepts',
        loadComponent: () =>
          import('./features/project/concepts/concepts.component').then(m => m.ConceptsComponent),
        title: 'Konzepte',
      },
      {
        path: 'groups',
        loadComponent: () =>
          import('./features/project/groups/groups.component').then(m => m.GroupsComponent),
        title: 'Gruppen',
      },
      {
        path: 'concepts/:conceptId',
        canActivate: [conceptExistsGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        loadComponent: () =>
          import('./features/project/concepts/concept-detail/concept-detail.component').then(
            m => m.ConceptDetailComponent
          ),
        title: 'Konzeptdetails',
      },
      {
        path: 'group/:groupId',
        canActivate: [groupExistsGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        loadComponent: () =>
          import('./features/project/concepts/group-wrapper/group-wrapper.component').then(
            m => m.GroupWrapperComponent
          ),
        title: 'Gruppe',
      },
      {
        path: 'architecture',
        loadComponent: () =>
          import('./features/project/architecture/architecture.component').then(
            m => m.ArchitectureComponent
          ),
        title: 'Architektur',
      },
      {
        path: 'adr/:adrId',
        canActivate: [adrExistsGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        loadComponent: () =>
          import('./features/project/architecture/adrs/adr-detail/adr-detail.component').then(
            m => m.AdrDetailComponent
          ),
        title: 'Adr',
      },
      {
        path: 'arc42/:number',
        canActivate: [arc42ChapterExistsGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        loadComponent: () =>
          import('./features/project/architecture/arc42-chapters/arc42-chapter-detail/arc42-chapter-detail.component').then(
            m => m.Arc42ChapterDetailComponent
          ),
        title: 'Arc42 Kapitel',
      },
      {
        path: 'api',
        loadComponent: () =>
          import('./features/project/api/api.component').then(m => m.ApiComponent),
        title: 'Schnittstellen',
      },
      {
        path: 'api/detail',
        canActivate: [apiSpecificationExistsGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        loadComponent: () =>
          import('./features/project/api/api-detail/api-detail.component').then(
            m => m.ApiDetailComponent
          ),
        title: 'API-Spezifikation',
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('@features/user/settings/settings.component').then(m => m.SettingsComponent),
        title: 'Profil',
      },
    ],
  },

  { path: '**', redirectTo: 'projects' },
];
